import * as navigation from 'Navigation';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';

export default class RunDetailsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: MODEL_NAMES.Run,
      closeable: false,
      preferenceKey: 'run-details',
    };
  }
}
